import { render, staticRenderFns } from "./LaundryTally.vue?vue&type=template&id=499b0c52&scoped=true"
import script from "./LaundryTally.vue?vue&type=script&lang=js"
export * from "./LaundryTally.vue?vue&type=script&lang=js"
import style0 from "./LaundryTally.vue?vue&type=style&index=0&id=499b0c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b0c52",
  null
  
)

export default component.exports